import { InternalCompilerError } from './../../InternalCompilerError';
import { ReturnBlock } from "../ReturnBlock";
import { ANDBlock } from "../returnBlocks/boolean/operators/ANDBlock";
import { VoidBlock } from "../VoidBlock";

export class IFBlock extends VoidBlock {
    condition; // the condition
    then; // what is executed if condition is true
    otherwise; // what is executed otherwise   
    len; //length

    /**
     * Constructor for an IF block
     * @param condition condition block of if statement (boolean). If more than one conditions
     * are passed in, the AND operation is performed.
     * @param then block evaluated if condition is true
     * @param otherwise block evaluated if condition is false
     */
    constructor(id: string, condition: ReturnBlock[],
        then: VoidBlock[],
        otherwise: VoidBlock[]) {
        super(id)
        this.condition = condition;
        this.then = then;
        this.otherwise = otherwise;

        let ifLen = 0, elseLen = 0;

        for (let block of then) {
            ifLen += block.getLength();
        }

        for(let block of otherwise){
            elseLen += block.getLength();
        }

        this.len = Math.max(ifLen, elseLen);
    }

    /**
     * Evaluates IF block. If condition is boolean and true, "then" block are evaluated, if condition is boolean
     * and false, "otherwise" blocks are executed. If condition is not boolean a TypeError is thrown. 
     * @param varEnv the variable envornment
     */
    *evalBlock(varEnv: Map<string, any>) {
        // evaluating the condition
        let andInpsConds = this.condition;
        const andBlock: ANDBlock = new ANDBlock(this.id, andInpsConds);
        const cond = andBlock.evalBlock(varEnv);
        const runBlocks = cond ? this.then : this.otherwise;

        for (let block of runBlocks) {
            if (!(block instanceof VoidBlock)) throw new InternalCompilerError('Loop body must be void');

            let gen = block.evalBlock(varEnv);
            let status;

            do {
                status = gen.next();
                yield;
            } while (!status.done);

        }

        return;
    }

    /**
     * Returns the maximimum minimum execution time for the if statement. (max between if and else sides' minimum
     * execution length).
     */
    getLength(){
        return this.len;
    }
}